/**
 * simplex controller
 */

import { factories } from '@strapi/strapi'

export default factories.createCoreController('plugin::telegram-bot.telegram-group');
